import AssignToCoursePage from "../../components/courses/assignToCourse";

const AssignToCourse = () => {
    return <AssignToCoursePage />;
  };
  export default AssignToCourse;
  